import { jsx as t, jsxs as a, Fragment as B } from "react/jsx-runtime";
import { HelpButton as N } from "./index.es10.js";
import { IconButton as D } from "./index.es16.js";
import { ToggleButton as L } from "./index.es8.js";
import { useMemo as l } from "react";
import _ from "classnames";
import { uniqueId as w } from "lodash/fp";
import i from "./index.es5750.js";
import { Divider as x } from "./index.es24.js";
import { Icon as H } from "./index.es157.js";
import { Heading as M } from "./index.es507.js";
const R = "drawer-template-header", k = ({
  title: s,
  actionType: e,
  testId: r = R,
  headingLevel: b = "span",
  toggleItems: c = [],
  toggleValue: m = "",
  onToggleChange: d,
  toggleDisabled: u,
  onClose: o,
  helpTooltip: p = "Learn More",
  onHelpClick: n,
  iconButtons: f = []
}) => {
  const A = l(() => e !== "toggle" ? null : /* @__PURE__ */ t("div", { className: i.toggleContainer, "data-testid": `${r}-toggle-container`, children: /* @__PURE__ */ t(
    L,
    {
      items: c,
      value: m,
      onChange: d || (() => {
      }),
      size: "small",
      testId: `${r}-toggle`,
      disabled: u
    }
  ) }), [e, c, m, d, u, r]), h = l(() => e !== "close-help" ? null : /* @__PURE__ */ a("div", { className: i.actionsContainer, "data-testid": `${r}-actions-container`, children: [
    n && /* @__PURE__ */ a(B, { children: [
      /* @__PURE__ */ t(
        N,
        {
          tooltip: p,
          onClick: n,
          testId: `${r}-help-button`
        }
      ),
      /* @__PURE__ */ t(x, { isVertical: !0, dividerLength: "24px" })
    ] }),
    o && /* @__PURE__ */ t(
      "button",
      {
        className: i.closeButton,
        "aria-label": "Close panel",
        onClick: o,
        "data-testid": `${r}-close-button`,
        children: /* @__PURE__ */ t(H, { type: "X", weight: "outline" })
      }
    )
  ] }), [e, n, p, o, r]), E = l(() => e !== "actions" ? null : /* @__PURE__ */ t("div", { className: i.iconButtonsActions, "data-testid": `${r}-icon-container`, children: f.map(($, v) => /* @__PURE__ */ t(
    D,
    {
      ...$,
      variant: "secondary-gray",
      testId: $.testId || `${r}-icon-button-${v}`
    },
    v
  )) }), [e, f, r]), g = `${w("region-")}-title`;
  return /* @__PURE__ */ a(
    "div",
    {
      className: _(i.header, { [i.hasBorder]: h }),
      "data-testid": r,
      role: "region",
      "aria-labelledby": g,
      "aria-label": `${s} section`,
      children: [
        /* @__PURE__ */ t(
          M,
          {
            variant: "h6",
            element: b,
            "data-testid": `${r}-title`,
            id: g,
            children: s
          }
        ),
        A,
        h,
        E
      ]
    }
  );
};
export {
  R as DRAWER_TEMPLATE_HEADER_DEFAULT_TESTID,
  k as DrawerTemplateHeader
};
//# sourceMappingURL=index.es905.js.map
